var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"main-title"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"main-body"},[_c('div',{ref:"preview",staticClass:"md-body",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }